/// <reference path="globalsettingsservice.ts" />
/// <reference path="../ilocalstorage.d.ts" />
/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="apiservice.ts" />
/// <reference path="logservice.ts" />
/// <reference path="../HiLOuser.ts" />

module App.Common.Services {
	'use strict';

	export class UsersService {

		public static $inject = [
			'$q',
			'app.common.services.logService',
			'$localStorage',
			'app.common.services.globalSettingsService',
			'app.common.services.apiService'
		];

		constructor(private $q: angular.IQService,
			private logger: Services.LogService,
			private $localStorage: Common.ILocalStorage,
			private globalSettings: Services.GlobalSettingsService,
			private api: Services.ApiService) {
		}

		public populateCurrentUserLocalStorage(): angular.IPromise<Common.HiLOUser> {

			if (this.$localStorage.currentUser) {
				return this.$q.resolve(new Common.HiLOUser(this.$localStorage.currentUser));
			}

			this.logger.debug('Getting current user data');

			return this.api.get({
					resourceName: 'CurrentUser'
				}).then((data: Hca.HiLO.ViewModel.IUserViewModel): Common.HiLOUser => {
					this.$localStorage.currentUser = data;
					// The above does not set the local storage soon enough
					// in the pipeline for the controller initialize() method
					// the below does however
					localStorage.setItem('hilo-currentUser', JSON.stringify(data));
					return new Common.HiLOUser(data);
				});
		}

		public clearCurrentUserLocalStorage(): void {
			delete this.$localStorage.currentUser;
		}

		public getCurrentUser() : Common.HiLOUser {
			return new Common.HiLOUser(this.$localStorage.currentUser);
		}

		public getUserById(id: any): angular.IPromise<Common.HiLOUser> {
			return this.api.get({
				resourceName: 'User',
				params: { id: id }
			})
			.then((data: Hca.HiLO.ViewModel.IUserViewModel): any => {
				return data;
			});	
		}
	}

	angular
		.module('app.common.services')
		.service('app.common.services.usersService', UsersService);
}